import React from "react";

const integrations = [
  { name: "Logistics" },
  { name: "Manufacturing" },
  { name: "Construction" },
  { name: "HealthCare" },
];

const Integrations = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">

        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-semibold text-[#111827]">
           Who We Support
          </h2>

          <span className="hidden sm:inline-flex items-center gap-2 px-4 py-1 text-sm border rounded-full text-gray-500 bg-white">
            🔒 Broad Coverage
          </span>
        </div>

        {/* Integrations List */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {integrations.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-3 bg-[#D9F4EF] text-[#0F766E] px-5 py-3 rounded-lg font-medium"
            >
              {/* Icon Placeholder */}
              <span className="flex items-center justify-center w-7 h-7 rounded-md bg-white text-[#0FB9B1] font-semibold text-sm">
                ⬡
              </span>

              <span>{item.name}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Integrations;
